export const LANGUAGES = ['UA', 'EN', 'DE', 'RU'];
